import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getSucursalesLista = async () => {
    const res = await getData('/sucursales/panel');
    return res
}

export const getSucursalById = async (id) => {
    const res = await getData(`/sucursales/${id}`)
    return res
}

export const postSucursal = async (body) => {
    const res = await postData('/sucursales', body)
    return res
}

export const patchSucursal = async (id, body) => {
    const res = await patchData(`/sucursales/${id}`, body)
    return res
}

export const deleteSucursal = async (id) => {
    const res = await deleteData(`/sucursales/${id}`)
    return res
}